import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';
import { IIncludePaymentRunResponse } from '../models/include-payment-run-response.model';

export const includePaymentRunFeatureKey = 'includePaymentRun';

export interface IncludePaymentRunState {
  success: IIncludePaymentRunResponse | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: IncludePaymentRunState = {
  success: null,
  failure: null,
  loading: false
};

export const includePaymentRunReducer = createReducer(
  initialState,
  on(fromPaymentsActions.includeInPaymentRun, (state) => ({
    ...state,
    loading: true,
    failure: null
  })),
  on(fromPaymentsActions.includeInPaymentRunSuccess, (state, { response }) => ({
    ...state,
    success: response,
    loading: false,
    failure: null
  })),
  on(fromPaymentsActions.includeInPaymentRunFailure, (state, { error }) => ({
    ...state,
    success: null,
    loading: false,
    failure: error
  })),
  on(fromPaymentsActions.clearIncludePaymentRunState, (state) => ({
    ...state,
    success: null,
    failure: null,
    loading: false
  }))
);
